<template>
    <div class="container" v-if="ListGarantidorasGeral!=''">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading"><h3 class="fw-bold">Contratações vigentes</h3><ul class="breadcrumbs"><li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li><li class="separator"><i class="fa fa-chevron-right"></i></li><li class="nav-item">Contratações</li><li class="separator"><i class="fa fa-chevron-right"></i></li><li class="nav-item">Vigentes</li></ul></div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Contratações Vigentes</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :headers="gridHeaders" :export-headers="headers" :filter-source-headers="filterHeaders"
                                    :filter-columns="4" :items="ListPedidosGeralFiltro"
                                    total-field="pedValorTotalPedido" total-label="Valor total filtrado"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="contratacoes-vigentes"
>
                                    <template #item-entidadesResumo="item"><div class="gp-contract-entity-summary"><strong>{{ item.garNome || '—' }}</strong><small>{{ item.imobNome || '—' }}</small></div></template>
                                    <template #item-clienteResumo="item"><div class="gp-contract-client-summary"><strong>{{ item.cliNome || '—' }}</strong><small>{{ item.cliDocumento || '—' }}</small></div>
                                    </template>
                                    <template #item-pedDataPedido="item">
                                        <span> {{ item.pedDataPedido !== null ? formattedDate(item.pedDataPedido) : null }}</span>
                                    </template>
                                    <template #item-pedValorTotalPedido="item">
                                        {{ item.pedValorTotalPedido !== null ? formatarValor(item.pedValorTotalPedido) : 0 }}
                                    </template>
                                    <template #item-pedSituacaoPedido="item">
                                        <span class="gp-contract-status-badge">{{ item.pedSituacaoPedido }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions"><button type="button" class="gp-table-action gp-action-edit" title="Abrir contratação" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button></div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import * as XLSX from 'xlsx';

export default {
    name: 'ListaContratacoesVigentesView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        User:[],
        searchValue: '',
        NomeTela:'Contratações',
        InfoTela:'Contratações Vigentes',
        MostraGrid: true,
        headers: [],
        Idiomas:[],
        vshowidioma: true,
        CadastroTelas:[{ cdtId: 28, cdtNome: "Contratações Vigentes" }],
        Pedidos:[],
        ListPedidosGeral:[],
        ListPedidosGeralFiltro:[],
        ListGarantidorasGeral:[],
    }),
    computed: {
        filterHeaders() {
            const camposOcultos = ['pedDataPedido', 'pedValorTotalPedido', 'pedSituacaoPedido'];
            return this.headers.filter(header => !camposOcultos.includes(header.value));
        },
        gridHeaders() {
            const resultado=[];let entidades=false;let cliente=false;
            this.headers.forEach(header=>{if(header.value==='garNome'||header.value==='imobNome'){if(!entidades){resultado.push({text:'Garantidora / Imobiliária',value:'entidadesResumo',sortable:false});entidades=true}}else if(header.value==='cliNome'||header.value==='cliDocumento'){if(!cliente){resultado.push({text:'Cliente / Documento',value:'clienteResumo',sortable:false});cliente=true}}else resultado.push(header)});
            return resultado;
        }
    },
    methods: {
        SelecionaSituacao(value){
            if (value > 0){          
                this.ListPedidosGeralFiltro = this.ListPedidosGeral.filter(x=> x.pspId == value);
            }
            else{
                this.ListPedidosGeralFiltro = this.ListPedidosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        EditGrid(item) {
            this.$router.push('/contratacaovigentedetalhe/' + encodeURIComponent(item.pedToken || item.pedId));
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Id", value: "pedId", sortable: true, });
            this.headers.push({ text: "Data", value: "pedDataPedido", sortable: true, });
            this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            this.headers.push({ text: "Imobiliaria", value: "imobNome", sortable: true, });
            this.headers.push({ text: "Cliente", value: "cliNome", sortable: true, });
            this.headers.push({ text: "Documento", value: "cliDocumento", sortable: true, });
            this.headers.push({ text: "Valor Total", value: "pedValorTotalPedido", sortable: true, });
            this.headers.push({ text: "Situação", value: "pedSituacaoPedido", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
       /* exportXLSX() {
            if (!this.ListPedidosGeralFiltro || this.ListPedidosGeralFiltro.length === 0) {
                alert("Não há dados para exportar.");
                return;
            }
            if (!this.headers || this.headers.length === 0) {
                alert("Sem colunas para exportar.");
                return;
            }

            // Cabeçalhos e chaves
            const headers = this.headers.map(h => String(h.text || ''));
            const keys    = this.headers.map(h => String(h.value || ''));

            // Helpers de inferência
            const isDocField = (label) => /(^|\b)(cpf|cnpj|documento|Garantidora|ie|cep|telefone|Imobiliaria|Cliente|conta|agencia|pix|codigo|código)\b/i.test(label);
            const isCurrency = (label) => /(valor|preço|preco|taxa|tarifa|total|subtotal|receita|Valor|despesa)/i.test(label);
            const isInteger  = (label) => /(id|qtd|quantidade|número|numero|ano)/i.test(label);
            const isISODate  = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?$/.test(v);
            const parseBRNumber = (v) => {
                if (typeof v === 'number') return v;
                if (v == null || v === '') return null;
                const s = String(v).trim().replace(/\./g, '').replace(',', '.');
                const n = parseFloat(s);
                return isNaN(n) ? null : n;
            };

            const garMap = new Map(
            (this.ListGarantidorasGeral || []).map(g => [String(g.garId), g.garNomeEmpresa])
            );

            const getGarNome = (garId) => {
            if (garId == null) return '';
            return garMap.get(String(garId)) || '';
            };

            // Mapeia colunas para tipos pretendidos
            const colMeta = headers.map((h, i) => {
                const key = keys[i] || '';
                const label = `${h} ${key}`;
                return {
                i,
                header: h,
                key,
                forceText: isDocField(label),
                currency: isCurrency(label),
                integer: isInteger(label)
                };
            });

            // Constrói linhas com rótulos = cabeçalhos
            const rows = this.ListPedidosGeralFiltro.map(item => {
                const row = {};
                colMeta.forEach(({ header, key, forceText, currency, integer }) => {
                let val = item?.[key];

                if (key === 'garId') {
                row[header] = getGarNome(val);
                return;
                }

                if (forceText) {
                    // Garante texto para preservar zeros à esquerda
                    row[header] = (val == null) ? '' : String(val);
                    return;
                }

                // Datas
                if (isISODate(val)) {
                    const d = new Date(val);
                    row[header] = isNaN(d.getTime()) ? (val ?? '') : d;
                    return;
                }

                // Números (moeda ou inteiros)
                if (currency) {
                    const n = parseBRNumber(val);
                    row[header] = (n == null) ? null : n;
                    return;
                }
                if (integer) {
                    const n = parseBRNumber(val);
                    row[header] = (n == null) ? null : Math.trunc(n);
                    return;
                }

                // Default
                row[header] = (val == null) ? '' : val;
                });
                return row;
            });

            // Cria a planilha
            const ws = XLSX.utils.json_to_sheet(rows, { header: headers, skipHeader: false });

            // Formata células por coluna (número, moeda, data)
            if (ws['!ref']) {
                const range = XLSX.utils.decode_range(ws['!ref']);
                const headerRow = range.s.r; // 0
                const dataStart = headerRow + 1;

                colMeta.forEach(({ i, currency, integer }) => {
                for (let r = dataStart; r <= range.e.r; r++) {
                    const addr = XLSX.utils.encode_cell({ c: i, r });
                    const cell = ws[addr];
                    if (!cell) continue;

                    // Datas (quando json_to_sheet detecta Date, já vem t='n' com serial; reforçamos formato)
                    // Se o valor original era Date, definimos formato
                    const isDateObj = rows[r - dataStart] && rows[r - dataStart][headers[i]] instanceof Date;

                    if (isDateObj) {
                    cell.t = 'd';
                    cell.z = 'dd/mm/yyyy';
                    continue;
                    }

                    // Moeda
                    if (currency && (typeof cell.v === 'number')) {
                    cell.t = 'n';
                    cell.z = '#,##0.00';
                    continue;
                    }

                    // Inteiro
                    if (integer && (typeof cell.v === 'number')) {
                    cell.t = 'n';
                    cell.z = '0';
                    continue;
                    }
                }
                });

                // AutoFiltro no cabeçalho
                ws['!autofilter'] = { ref: ws['!ref'] };
            }

            // Larguras de coluna (baseado em cabeçalho + amostra de linhas)
            const sampleCount = Math.min(rows.length, 200);
            ws['!cols'] = headers.map((h, c) => {
                let max = String(h || '').length;
                for (let r = 0; r < sampleCount; r++) {
                const v = rows[r]?.[h];
                const s = v instanceof Date ? 'dd/mm/yyyy' : (v == null ? '' : String(v));
                if (s.length > max) max = s.length;
                }
                // margem e limite
                const wch = Math.min(Math.max(max + 2, 8), 50);
                return { wch };
            });

            // Gera workbook e salva
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Vigentes');
            XLSX.writeFile(wb, 'RelatorioListaVigentes.xlsx', { compression: true });
        },*/
       exportXLSX() {
  if (!this.ListPedidosGeralFiltro || this.ListPedidosGeralFiltro.length === 0) {
    alert("Não há dados para exportar.");
    return;
  }
  if (!this.headers || this.headers.length === 0) {
    alert("Sem colunas para exportar.");
    return;
  }

  // Cabeçalhos e chaves
  const headers = this.headers.map(h => String(h.text || ''));
  const keys    = this.headers.map(h => String(h.value || ''));

  // Helpers de inferência
  const isDocField = (label) =>
    /(^|\b)(cpf|cnpj|documento|garantidora|ie|cep|telefone|imobiliaria|cliente|conta|agencia|pix|codigo|código)\b/i.test(label);

  const isCurrency = (label) =>
    /(valor|preço|preco|taxa|tarifa|total|subtotal|receita|despesa)/i.test(label);

  const isInteger = (label) =>
    /(id|qtd|quantidade|número|numero|ano)/i.test(label);

  // ISO (com T ou com timezone)
  const isISODate = (v) =>
    typeof v === 'string' &&
    /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?$/.test(v);

  // SQL datetime: "2025-02-14 11:08:15.000"
  const isSqlDateTime = (v) =>
    typeof v === "string" &&
    /^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(v);

  const parseSqlDateTimeLocal = (s) => {
    const [datePart, timePart] = String(s).trim().split(" ");
    if (!datePart || !timePart) return null;

    const [Y, M, D] = datePart.split("-").map(Number);

    const [hh, mm, ssMs] = timePart.split(":");
    const [ss, msRaw = "0"] = String(ssMs || "0").split(".");
    const ms = Number(String(msRaw).padEnd(3, "0").slice(0, 3));

    const d = new Date(Y, (M - 1), D, Number(hh), Number(mm), Number(ss), ms); // local
    return isNaN(d.getTime()) ? null : d;
  };

  const parseBRNumber = (v) => {
    if (typeof v === 'number') return v;
    if (v == null || v === '') return null;
    const s = String(v).trim().replace(/\./g, '').replace(',', '.');
    const n = parseFloat(s);
    return isNaN(n) ? null : n;
  };

  // Map de garantidoras
  const garMap = new Map(
    (this.ListGarantidorasGeral || []).map(g => [String(g.garId), g.garNomeEmpresa])
  );

  const getGarNome = (garId) => {
    if (garId == null) return '';
    return garMap.get(String(garId)) || '';
  };

  // Mapeia colunas para tipos pretendidos
  const colMeta = headers.map((h, i) => {
    const key = keys[i] || '';
    const label = `${h} ${key}`;
    return {
      i,
      header: h,
      key,
      forceText: isDocField(label),
      currency: isCurrency(label),
      integer: isInteger(label)
    };
  });

  // Constrói linhas (rótulos = cabeçalhos)
  const rows = this.ListPedidosGeralFiltro.map(item => {
    const row = {};

    colMeta.forEach(({ header, key, forceText, currency, integer }) => {
      let val = item?.[key];

      // Garantidora: exporta nome
      if (key === 'garId') {
        row[header] = getGarNome(val);
        return;
      }

      // Texto forçado (documentos etc.)
      if (forceText) {
        row[header] = (val == null) ? '' : String(val);
        return;
      }

      // Datas SQL "YYYY-MM-DD HH:mm:ss.fff"
      if (isSqlDateTime(val)) {
        const d = parseSqlDateTimeLocal(val);
        row[header] = d ?? (val ?? '');
        return;
      }

      // Datas ISO (se vier)
      if (isISODate(val)) {
        const d = new Date(val);
        row[header] = isNaN(d.getTime()) ? (val ?? '') : d;
        return;
      }

      // Números (moeda ou inteiros)
      if (currency) {
        const n = parseBRNumber(val);
        row[header] = (n == null) ? null : n;
        return;
      }
      if (integer) {
        const n = parseBRNumber(val);
        row[header] = (n == null) ? null : Math.trunc(n);
        return;
      }

      // Default
      row[header] = (val == null) ? '' : val;
    });

    return row;
  });

  // Cria a planilha (cellDates ajuda a manter Date como Date)
  const ws = XLSX.utils.json_to_sheet(rows, {
    header: headers,
    skipHeader: false,
    cellDates: true
  });

  // Formata células por coluna
  if (ws['!ref']) {
    const range = XLSX.utils.decode_range(ws['!ref']);
    const headerRow = range.s.r; // 0
    const dataStart = headerRow + 1;

    colMeta.forEach(({ i, currency, integer }) => {
      for (let r = dataStart; r <= range.e.r; r++) {
        const addr = XLSX.utils.encode_cell({ c: i, r });
        const cell = ws[addr];
        if (!cell) continue;

        const rowObj = rows[r - dataStart];
        const isDateObj = rowObj && rowObj[headers[i]] instanceof Date;

        if (isDateObj) {
          cell.t = 'd';
          cell.z = 'dd/mm/yyyy hh:mm:ss'; // ou 'dd/mm/yyyy' se quiser só a data
          continue;
        }

        if (currency && typeof cell.v === 'number') {
          cell.t = 'n';
          cell.z = '#,##0.00';
          continue;
        }

        if (integer && typeof cell.v === 'number') {
          cell.t = 'n';
          cell.z = '0';
          continue;
        }
      }
    });

    // AutoFiltro
    ws['!autofilter'] = { ref: ws['!ref'] };
  }

  // Larguras de coluna
  const sampleCount = Math.min(rows.length, 200);
  ws['!cols'] = headers.map((h) => {
    let max = String(h || '').length;
    for (let r = 0; r < sampleCount; r++) {
      const v = rows[r]?.[h];
      const s = v instanceof Date ? 'dd/mm/yyyy hh:mm:ss' : (v == null ? '' : String(v));
      if (s.length > max) max = s.length;
    }
    const wch = Math.min(Math.max(max + 2, 8), 50);
    return { wch };
  });

  // Gera workbook e salva
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Vigentes');

  XLSX.writeFile(wb, 'RelatorioListaVigentes.xlsx', {
    compression: true,
    cellDates: true
  });
},

        async Get() {

          await axios.get(`/Telas/ContratacoesVigentes/GetDados`)
                .then(response => {
                    const todasGarantidoras = response.data.garantidoras || [];
                    this.ListGarantidorasGeral = todasGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                            b.garNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );

                    const garantidorasPorId = new Map(todasGarantidoras.map(item => [String(item.garId), item.garNomeEmpresa]));
                    this.ListPedidosGeral = (response.data.pedidos || []).map(item => ({ ...item, garNome: garantidorasPorId.get(String(item.garId)) || '' }));
                    this.ListPedidosGeralFiltro = this.ListPedidosGeral.sort((a, b) => {
                                                                        const valorA = parseInt(a.pedId) || 0;
                                                                        const valorB = parseInt(b.pedId) || 0;
                                                                        return valorA - valorB;
                                                                    }).reverse();
                    this.montaGrid();
                });           
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
.gp-contract-entity-summary,.gp-contract-client-summary{display:flex;max-width:235px;flex-direction:column;gap:2px;line-height:1.25;white-space:normal;word-break:break-word}.gp-contract-entity-summary strong,.gp-contract-client-summary strong{color:#17223b;font-size:10.5px}.gp-contract-entity-summary small,.gp-contract-client-summary small{color:#718096;font-size:9.5px}.gp-contract-status-badge{display:inline-flex;align-items:center;justify-content:center;min-height:22px;padding:3px 8px;border-radius:999px;background:#e7f7f1;color:#157052;font-size:9px;font-weight:800;white-space:nowrap}
</style>
